
import { defineComponent } from '@vue/composition-api';
import AttributesHotelFilter from '@ve/components/filters/common/components/attributesHotelFilter/AttributesHotelFilter.vue';
import FilterPostWrapper from '@ve/components/searchFilters/filterList/desktop/FilterPostWrapper.vue';
import useFilterAttributesAnalytics from '@ve/components/filters/common/use/useFilterAttributesAnalytics';
import useFilterAttributesHotel from '@ve/components/filters/common/use/useFilterAttributesHotel';
import FacilitiesFilterAttributeMethods from './FacilitiesFilterAttributeMethods';

export default defineComponent({
    name: 'FacilitiesFilter',
    components: {
        AttributesHotelFilter,
        FilterPostWrapper,
    },
    setup() {
        return {
            FacilitiesFilterAttributeMethods,
            ...useFilterAttributesAnalytics(FacilitiesFilterAttributeMethods),
            ...useFilterAttributesHotel('facilitiesFilter'),
        };
    },
});
